import { useState } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../../../Components-2/Footer";
import Header from "../../../Components-2/Header/Header";
import Sidebar1 from "../../../Components-2/Sidebar1";
import "./DailyBooking.css";

import ShortEntry from "./ShortEntry";
import TrackingBooking from "./TrackingBooking";
import TrackingBulk from "./TrackingBulk";
import BulkUpdate from "../POD Update/BulkUpdate";

function ShortEntryTabs() {
  const location = useLocation();


  const permissions = JSON.parse(localStorage.getItem("Login")) || {};
  const has = (key) => permissions[key] === 1;

  const [activeTab, setActiveTab] = useState(location?.state?.tab || null);

  // 🔥 NEW: shared docket state
  const [selectedDocket, setSelectedDocket] = useState(null);
  const [selectedRateData, setSelectedRateData] = useState(null);

  const tabs = [
    
    
    {
      id: "smart",
      label: "Smart Booking",
      component: <ShortEntry />,
      show: has("Smartbooking"),
    },
     {
      id: "tarcking",
      label: "Tracking Booking",
      component: <TrackingBooking />,
      show: 1,
    },
     {
      id: "excel",
      label: "Bulk Upload Tracking",
      component: <TrackingBulk />,
      show: 1,
    },
    {
      id: "del",
      label: "Bulk Delivered",
      component: <BulkUpdate />,
      show: has("Smartbooking"),
    },
  ];

  const visibleTabs = tabs.filter((t) => t.show);

  if (!activeTab && visibleTabs.length > 0) {
    setActiveTab(visibleTabs[0].id);
  }

  return (
    <>
      <Header />
      <Sidebar1 />

      <div id="main-body">
        <div className="container">

          {/* NAVIGATION */}
          <nav>
            {visibleTabs.map((tab) => (
              <label
                key={tab.id}
                
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </label>
            ))}

            <div
              className="slider"
              style={{
                left: `${
                  visibleTabs.findIndex((t) => t.id === activeTab) *
                  (100 / visibleTabs.length)
                }%`,
                width: `${100 / visibleTabs.length}%`,
              }}
            />
          </nav>

          {/* TAB CONTENT */}
          <section>
            {visibleTabs.find((t) => t.id === activeTab)?.component}
          </section>

        </div>
        <Footer />
      </div>
    </>
  );
}

export default ShortEntryTabs;
